<template>
    <div class="send-form" ref="sendForm" :style="{height}">
        <div class="title">
            <span class="icon far fa-inbox-out"></span>Send Form
        </div>
        <div v-if="forms">
            <div class="subtitle">Choose how to send this form</div>
            <div v-for="(form, index) in forms" :key="index" class="form" :title="form.name">
                <i :class="formIconClass"></i>
                {{ form.name }}
            </div>
            <div class="send" @click="selectMethod()" :class="{ disabled }">
                <div class="icon">
                    <i class="far fa-envelope-open-text"></i>
                </div>
                <div class="v-split">
                    <div class="heading">Send Form to One Recipient</div>
                    <div
                        class="info"
                    >For an email or other type of message where the form will only be completed by one person.</div>
                </div>
            </div>
            <div class="send" @click="selectMethod(true)" :class="{ disabled }">
                <div class="icon">
                    <i class="far fa-link"></i>
                </div>
                <div class="v-split">
                    <div class="heading">Get Link to Post Form Publicly</div>
                    <div
                        class="info"
                    >For posting on a website, social media, or another public platform where the form will be completed by many people.</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { strings, constants } from '../../utils';

    export default {
        name: 'ChoosePackageType',
        data() {
            return {
                isPublic: false,
                height: 'auto',
                disabled: false
            };
        },
        props: {
            forms: {
                type: Array,
            },
        },
        computed: {
            formIconClass() {
                return constants.ICONS.FORM;
            },
        },
        methods: {
            async selectMethod(isPublic) {
                if (this.disabled) return;
                this.disabled = true;
                this.$store.dispatch('dialog/emit', {
                    name: 'select',
                    payload: isPublic,
                });
            },
        },
        async mounted() {
            await this.$nextTick();
            this.height = strings.pixelate(this.$refs.sendForm.offsetHeight);
        },
    };
</script>

<style lang="scss" scoped>
    $height-title: 25px;
    $padding-container: 1em;

    .send-form {
        font-size: $font-size-smaller;
        padding: 0.5em;
        overflow: hidden;
        position: relative;
    }

    .title {
        font-weight: $bold;
        font-size: $font-size-larger;
        margin-bottom: 0.35em;
        height: $height-title;

        .icon {
            margin-right: 0.35em;
        }
    }

    .subtitle {
        color: $color-disabled-text;
        margin-bottom: 0.5em;
    }

    .form {
        @include border-radius-small;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background: $color-disabled-bg;
        padding: 0.5em 0.75em;
        margin-bottom: 1em;
    }

    .send {
        @include border-radius-small;
        @include border;

        display: flex;
        cursor: pointer;
        transition: color 0.2s, border-color 0.2s, background-color 0.2s;

        &:hover:not(.disabled) {
            color: $color-white;
            background: $color-highlight;
            border-color: $color-highlight;
        }

        &:not(:last-child) {
            margin-bottom: 0.5em;
        }

        &.disabled {
            color: $color-disabled-text;
            background-color: $color-disabled-bg;
        }

        .icon {
            display: flex;
            width: 50px;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;

            i {
                font-size: 20px;
            }
        }

        .v-split {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            padding: 0.5em 0.75em 0.5em 0;

            .heading {
                font-weight: $bold;
                margin-bottom: 0.25em;
            }
        }
    }
</style>
